import { QuestionOption } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionOption';
import { QuestionTitle } from '@/components/decision-tree/components/SurveyItem/components/Question/components/QuestionTitle';
import { IDontKnowAnswer } from '@/components/decision-tree/hooks';
import { Box } from '@cmpsr/components';
import { ChangeEvent, FC, useEffect, useState } from 'react';
import { MultipleChoiceAnswer, MultipleChoiceProps } from './types';

export const optionNoneId = 'none';

export const MultipleChoice: FC<MultipleChoiceProps> = ({
  data,
  saveAnswer,
  defaultValue,
  whyWeAskModalDisclosure,
}) => {
  const { label, options, whyWeAskExplanation, id, tooltip, description } = data;
  const [answers, setAnswers] = useState<MultipleChoiceAnswer>({ type: 'multipleChoice', values: [] });

  useEffect(() => {
    const values =
      (defaultValue as IDontKnowAnswer)?.type === 'iDontKnow' || !defaultValue
        ? []
        : (defaultValue as MultipleChoiceAnswer)?.values?.length
        ? (defaultValue as MultipleChoiceAnswer).values
        : options.reverse().findIndex(({ type }) => (type = 'none')) >= 0
        ? [optionNoneId]
        : [];

    setAnswers({ type: 'multipleChoice', values });
    saveAnswer({ type: 'multipleChoice', values });
  }, [id]);

  const handleNoneChange = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    const newAnswers = !currentTarget.checked
      ? { ...answers, values: answers.values.filter((answer) => answer !== currentTarget.value) }
      : { ...answers, values: [currentTarget.value] };
    setAnswers(newAnswers);
    saveAnswer(newAnswers);
  };

  const handleChange = ({ currentTarget }: ChangeEvent<HTMLInputElement>) => {
    const newAnswers = !currentTarget.checked
      ? { ...answers, values: answers.values.filter((answer) => answer !== currentTarget.value) }
      : { ...answers, values: [...answers.values.filter((answer) => answer !== optionNoneId), currentTarget.value] };
    setAnswers(newAnswers);
    saveAnswer(newAnswers);
  };

  return (
    <Box width="full" maxWidth="450px">
      <QuestionTitle
        description={description}
        tooltip={tooltip}
        question={label}
        whyWeAskExplanation={whyWeAskExplanation}
        whyWeAskModalDisclosure={whyWeAskModalDisclosure}
      />
      <Box mt={6}>
        {options.map(({ id = optionNoneId, label, description, type }) => (
          <QuestionOption
            key={`multipleChoice-${id}`}
            componentType="checkbox"
            componentProps={{
              value: id,
              defaultChecked: (defaultValue as MultipleChoiceAnswer)?.values?.includes(id),
              isChecked: answers.values.includes(id),
              onChange: type === 'none' ? handleNoneChange : handleChange,
            }}
            label={label}
            description={description}
          />
        ))}
      </Box>
    </Box>
  );
};
